// Compose function for easier currying of functions. First in Last out.
// compose(fn1(), fn2(), fn3()...) === fn1(fn2(fn3(...)))
export const compose = (...fns) => x =>
	fns.reduceRight((acc, curr) => curr(acc), x);
